/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesIllustration } from '../../../constants/Proptypes';

const propTypesSliceSocialProof = {
  social_proof_title: PropTypes.string,
  social_proof_subtitle: PropTypes.string,
};

const propTypesItemsSocialProof = {
  social_proof_logo: propTypesIllustration,
};

export const propTypesDataSocialProof = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceSocialProof),
  items: PropTypes.shape(propTypesItemsSocialProof),
};
